import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Group } from '../../../../models/group.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';

@Component({
  selector: 'app-dlg-select-group',
  standalone: true,
  imports: [MatDialogModule, InitialsPipe],
  templateUrl: './dlg-select-group.component.html',
  styleUrls: ['./dlg-select-group.component.css']
})
export class DlgSelectGroupComponent {
  readonly dialogRef = inject(MatDialogRef<DlgSelectGroupComponent>);
  readonly data = inject<any>(MAT_DIALOG_DATA);

  groups: Group[] = [];
  selectedGroup: Group | null = null;
  isOpen = false;

  constructor() {
    this.groups = this.data.groups || [];
    // Pre-select the first group if available
    if (this.groups.length > 0) {
      this.selectedGroup = this.groups[0];
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  selectGroup(group: Group) {
    this.selectedGroup = group;
    this.isOpen = false;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  submit(): void {
    this.dialogRef.close(this.selectedGroup);
  }
}
